// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import zoneElementsSelector from "@store/Framework/Common/Utilities/zoneElementsSelector";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

export interface HeaderStyles {
    container?: InjectableCss;
    websiteName?: InjectableCss;
    logoWrapper?: InjectableCss;
    navigationWrapper?: InjectableCss;
    searchNavigationWrapper?: InjectableCss;
    loginCart?: InjectableCss;
    buttomLogoWrapper?: InjectableCss;
    mainNavigation?: HiddenProps;
    search?: InjectableCss;
}

export const headerStyles: HeaderStyles = {
    container: {
        css: css`
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        null,
                        css`
                            padding-top: 0.875em;
                            padding-bottom: 0.875em;
                        `,
                    ],
                    mediaOptions.max,
                )}
        `,
    },
    websiteName: {
        css: css`
            @media print {
                display: block;
            }
            font-size: ${pxToRem(12)};
            padding-left: ${pxToRem(15)};
            display: none;
        `,
    },
    logoWrapper: {
        css: css`
            flex-grow: 1;
            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        css`
                            margin: 0 1.5em 0 1.25em;
                        `,
                        null,
                        css`
                            margin: 0;
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    buttomLogoWrapper: {
        css: css`
            position: fixed;
            bottom: ${pxToRem(16)};
            left: ${pxToRem(16)};
        `,
    },
    searchNavigationWrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: flex-end;
            color: ${getColor("primary.contrast")};
        `,
    },
    mainNavigation: {
        css: css`
            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        css`
                            ${contentSpacingStyles(0, pxToRem(15), 0)}
                        `,
                        null,
                        css`
                            ${contentSpacingStyles(0, pxToRem(5), 0)}
                        `,
                        css`
                            ${contentSpacingStyles(0, pxToRem(35), 0)}
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    search: {
        css: css`
            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        css`
                            width: auto;
                        `,
                        null,
                        css`
                            width: ${pxToRem(300)};
                            ${contentSpacingStyles(0, pxToRem(5), 0, pxToRem(5))}
                        `,
                        css`
                            ${contentSpacingStyles(0, pxToRem(15), 0, pxToRem(15))}
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    loginCart: {
        css: css`
            > * {
                display: flex;
                align-items: center;
            }

            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        css`
                            ${contentSpacingStyles(0, 0, 0, pxToRem(15))}

                            ${zoneElementsSelector} {
                                ${contentSpacingStyles(0, pxToRem(15), 0)}
                            }
                        `,
                        css`
                            ${contentSpacingStyles(0, 0, 0, pxToRem(15))}
                        `,
                        css`
                            ${contentSpacingStyles(0, 0, 0, pxToRem(15))}
                            ${zoneElementsSelector} {
                                ${contentSpacingStyles(0, 0, 0, pxToRem(15))}
                            }
                        `,
                        css`
                            ${contentSpacingStyles(0, 0, 0, pxToRem(20))}

                            ${zoneElementsSelector} {
                                ${contentSpacingStyles(0, pxToRem(20), 0)}
                            }
                        `,
                    ],
                    mediaOptions.min,
                )}

            ${zoneElementsSelector} {
                vertical-align: middle;
            }
        `,
    },
};

const styles = headerStyles;

const HeaderContainer = ({ id }: Props) => {
    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.mainNavigation}>
                <Zone contentId={id} zoneName="MainNavigation" />
            </StyledWrapper>
            <StyledWrapper {...styles.logoWrapper}>
                <Zone contentId={id} zoneName="Logo" />
            </StyledWrapper>
            <StyledWrapper {...styles.search}>
                <Zone contentId={id} zoneName="Search" />
            </StyledWrapper>
            <Hidden below="md">
                <StyledWrapper {...styles.loginCart}>
                    <Zone contentId={id} zoneName="LoginAndCart" />
                </StyledWrapper>
            </Hidden>
        </StyledWrapper>
    );
};

const headerContainer: WidgetModule = {
    component: HeaderContainer,
    definition: {
        group: "Header",
        displayName: "Header Container",
        allowedContexts: ["Header"],
    },
};
export default headerContainer;
